import React from 'react';
import Browser from '../Browser';
import UnderConstruction from '../UnderConstruction';

const Stone = () => {
    const history = [
        'https://github.com/stonebk',
        'http://myloancalc.com/',
        'https://www.zillow.com/mortgage-rates/',
        'http://markioannidis.com/'
    ];
    return (
        <Browser title="Welcome to stonebk.com!"
                 address="http://www.stonebk.com/"
                 history={history}>
            <UnderConstruction />
            <UnderConstruction />
            <UnderConstruction />
            <UnderConstruction />
            <UnderConstruction />
        </Browser>
    );
};

export default Stone;



// WEBPACK FOOTER //
// ./src/components/windows/Stone.jsx